import { render, staticRenderFns } from "./SupportFAQ.vue?vue&type=template&id=d521de80&"
import script from "./SupportFAQ.vue?vue&type=script&lang=js&"
export * from "./SupportFAQ.vue?vue&type=script&lang=js&"
import style0 from "./SupportFAQ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports